import $ from 'jquery';

export const ISO_DATE_FORMAT = 'YYYY-MM-DD';

/**
 * Checks whether value is non-empty.
 *
 * @param {*} value
 * @returns {boolean}
 */
export function has(value) {
    return '' !== value && null !== value && undefined !== value;
}

/**
 * Left pads a string or number with zeros.
 *
 * @param {string|number} num - Number to pad
 * @param {number} places - Number of digits in final string
 * @returns {string}
 */
export function zeroPad(num, places) {
    return ('' + num).padStart(places, '0');
}

export function saveScrollPos() {
    $('#scrollPos').val(window.scrollY);
}

export function restoreScrollPos() {
    const scrollPos = $('#scrollPos').val();
    const hasActionError = $('div.alert-error').filter(':visible').length > 0;
    if (scrollPos && !window.location.hash && !hasActionError) {
        $(window).scrollTop(parseInt(scrollPos, 10));
    }
}

/****************************************************************************************************
 * bitmask code
 * 0000     0000        0000        0000            0000            0000 <-- * 7
 *
 * 0,1,2,3  4,5,6,7     8,9,10,11   12,13,14,15     16,17,18,19     20,21,22,23
 *
 * ex
 * 1:000E00 000E00 000E00 000E00 000E00 000000 000000
 * (man-fre 12-15)
 * ex
 * 2:000000000000 000000000000 000000000000 000000000000 000000000000 001F80FE0000 001F80FE0000
 * (lør-søn 5:30-8:30 og 12:00-15:30, mellemrum tilføjet for læselighed)
 ****************************************************************************************************/
export function convertHexStringToBitMask(str) {
    const digits = str.split(":")[1].split('');
    const bytes = [];

    for (const digit of digits) {
        const bits = parseInt(digit, 16).toString(2).padStart(4, '0');
        bytes.push(bits);
    }
    return bytes.join("").split("").map(Number);
}

/**
 * Builds a selector for site fields.
 *
 * @param {string} fieldName - Name of field
 * @param {string} siteIndex - Index of site as a string
 * @returns {string}
 */
export function siteFieldSelector(fieldName, siteIndex) {
    return `input[name='caseBean.sites[${siteIndex}].${fieldName}']`;
}
